"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    MuiButton: {
        root: {
            borderRadius: 9999,
        },
        contained: {
            '&.Mui-disabled': {
                background: 'none',
                color: theme.palette.text.secondary,
                border: `solid 1px ${theme.palette.divider}`,
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL292ZXJyaWRlcy9idXR0b24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxrQkFBZSxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDdkIsU0FBUyxFQUFFO1FBQ1QsSUFBSSxFQUFFO1lBQ0osWUFBWSxFQUFFLElBQUk7U0FDbkI7UUFDRCxTQUFTLEVBQUU7WUFDVCxnQkFBZ0IsRUFBRTtnQkFDaEIsVUFBVSxFQUFFLE1BQU07Z0JBQ2xCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxTQUFTO2dCQUNuQyxNQUFNLEVBQUUsYUFBYSxLQUFLLENBQUMsT0FBTyxDQUFDLE9BQU8sRUFBRTthQUM3QztTQUNGO0tBQ0Y7Q0FDRixDQUFDLENBQUMifQ==